var isHttpUrl = function (value) {
    try {
        var protocol = new URL(value).protocol;
        return protocol === "http:" || protocol === "https:";
    }
    catch (_a) {
        return false;
    }
};
export var resolvePublicCatalogLink = function (record) {
    var _a;
    var url = (_a = record === null || record === void 0 ? void 0 : record.publicCatalogUrl) === null || _a === void 0 ? void 0 : _a.trim();
    if (!url || !isHttpUrl(url)) {
        return { kind: "none" };
    }
    return (record === null || record === void 0 ? void 0 : record.publicCatalogVisible)
        ? { kind: "link", url: url }
        : { kind: "not-public" };
};
